import { useCallback } from 'react';
import { useBrandMainSupplierResetMutation } from 'api';
import { useParams } from 'react-router-dom';
import { notification } from 'components';
import { ErrorMappingValueType } from 'typings';

export const useMainSupplierRemoveModal = ({ onModalStateChange }: { onModalStateChange: () => void }) => {
  const { id } = useParams() as { id: string };
  const [resetMainSupplier, { isLoading }] = useBrandMainSupplierResetMutation();

  const handleCancel = useCallback(() => {
    onModalStateChange();
  }, [onModalStateChange]);

  const [notificationApi, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({ message: message });
    },
    [notificationApi]
  );

  const handleSubmit = useCallback(async () => {
    try {
      const payload = {
        brandId: id,
      };
      const { data, error }: Record<string, any> = await resetMainSupplier(payload);
      if (data?.success) {
        openNotificationWithIcon({
          type: 'success',
          message: 'Main Supplier was successfully removed.',
        });
        handleCancel();
      } else if (error?.data?.success === false) {
        Object.values(error?.data?.data || {}).forEach((message) => {
          openNotificationWithIcon({
            type: 'error',
            message: message as string,
          });
        });
      } else if (error?.data?.error) {
        openNotificationWithIcon({
          type: 'error',
          message: 'Something went wrong!',
        });
      }
    } catch (err) {
      console.error('Error removing main supplier:', err);
      openNotificationWithIcon({
        type: 'error',
        message: 'An unexpected error occurred. Please try again.',
      });
    }
  }, [id, openNotificationWithIcon, handleCancel, resetMainSupplier]);

  return {
    handleCancel,
    handleSubmit,
    contextHolder,
    isLoading,
  };
};
